import React, { FunctionComponent } from "react";
import Alert from "react-bootstrap/Alert";
import { Claim } from "../../../../types";
import "../DetailView.css";

type FinancialsProps = {
  dataSelected: Claim;
};
const Financials: FunctionComponent<FinancialsProps> = props => {
  const { dataSelected } = props;

  const formatCurrency = (value: number) => {
    const formatter = new Intl.NumberFormat("en-NZ", {
      style: "currency",
      currency: "NZD",
      maximumFractionDigits: 2
    });

    return formatter.format(value);
  };

  const getFinancials = () => {
    if (!dataSelected) {
      return null;
    }

    return (
      <div className="format-section" style={{ flexWrap: "nowrap" }}>
        <div>
          <div className="format-fields">
            <div className="label">Sum Insured Inc GST</div>
            <div className="value">
              {formatCurrency(dataSelected.sumInsured)}
            </div>
          </div>
          <div className="format-fields">
            <div className="label">Recommended Reserve</div>
            <div>
              <div className="value">
                {formatCurrency(dataSelected.recommendedReserve)}
              </div>
            </div>
          </div>
          <div className="label">EQC Land Reserve Inc GST</div>
            <div>
              <div className="value">
                {formatCurrency(dataSelected.eqcLandReserve)}
              </div>
            </div>
        </div>

        <div>
          <div className="format-fields">
            <div className="label">Contract Value</div>
            <div className="value">
              {formatCurrency(dataSelected.contractValue)}
            </div>
          </div>

          <div className="format-fields">
            <div className="label">Total Variations</div>
            <div className="value">
              {formatCurrency(dataSelected.totalVariations)}
            </div>
          </div>
            <div className="label">EQC Building Reserve Inc GST</div>
            <div>
              <div className="value">
                {formatCurrency(dataSelected.eqcBuildingReserve)}
              </div>
          </div>
        </div>

        <div>
          <div className="format-fields">
            <div className="label">Total Authorized</div>
            <div className="value">
              {formatCurrency(dataSelected.totalAuthorized)}
            </div>
          </div>
          <div className="format-fields">
            <div className="label">Total Outstanding Authorized</div>
            <div className="value">
              {formatCurrency(dataSelected.totalOutstandingAuthorized)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="detail-wrapper">
        <div className="heading">Claim Financials</div>
        <Alert variant={"warning"}>
          When reviewing a claim, please ensure the ‘Sum Insured’ is correct.
        </Alert>

        {getFinancials()}
      </div>
    </>
  );
};

export default Financials;
